export default (state = {}, action) => {
  switch (action.type) {
    case 'FINISH_INITIAL_LOAD':
      return {
        ...state,
        initialLoadCompleted: true
      }

    default:
      return state
  }
}
